import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const StatsPanel = ({ totalExecutives }) => {
  const { t } = useLanguage();
  
  const stats = [
    {
      icon: 'Users',
      value: totalExecutives,
      label: t('preview.cSuiteExecutives'),
      color: '#0025cc'
    },
    {
      icon: 'Award',
      value: '12+',
      label: t('preview.avgYearsExperience'),
      color: '#10B981'
    },
    {
      icon: 'TrendingUp',
      value: '94%',
      label: t('preview.avgMatchScore'),
      color: '#F59E0B'
    },
    {
      icon: 'Target',
      value: '100%',
      label: t('preview.identityProtected'),
      color: '#EF4444'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {stats?.map((stat, index) => (
        <div 
          key={index}
          className="bg-white/40 backdrop-blur-xl border border-white/20 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
        >
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#0025cc]/10 to-[#0025cc]/10 flex items-center justify-center">
              <Icon name={stat?.icon} size={20} color={stat?.color} />
            </div>
            <div className="text-2xl md:text-3xl font-bold text-[#111827]">{stat?.value}</div>
          </div>
          <div className="text-sm font-medium text-[#6B7280]">{stat?.label}</div>
        </div>
      ))}
    </div>
  );
};

export default StatsPanel;